import styled from 'styled-components'

export const StatsContainer = styled.section`
  background-color: #f9f9f9;
  text-align: center;
`

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 40px;
  background-color: white;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const StatItem = styled.div`
  font-family: Poppins;
  padding-block: 1.2rem;
`

export const StatNumber = styled.h2`
  font-family: Poppins;
  font-size: 4rem;
  color: #000;
  margin-bottom: 10px;

  @media (max-width: 720px) {
    font-size: 2.25rem;
  }
`

export const StatLabel = styled.p`
  font-family: Poppins;
  font-size: 1.5rem;
  color: #000;
  @media (max-width: 720px) {
    font-size: 0.8rem;
  }
`

export const LogosContainer = styled.div`
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  span {
    font-family: Poppins;
    font-size: 3.5rem;
    color: #fa8c16;
    font-weight: bold;
  }

  @media (max-width: 720px) {
    span {
      font-size: 2rem;
    }
  }
`
export const Logo = styled.img`
  width: 200px;
  height: 150px;
  margin: 0 20px;
  border-radius: 9.61px;
  background-color: #e6e6e6;
`
